import { CommunicationDisplayConditionsDto } from '@zorro/clients';

const EMPLOYEE_ACTION_LABELS: Partial<
  Record<keyof CommunicationDisplayConditionsDto, string>
> = {
  isCarrierApplicationElectionSubmitted: 'Special carrier requirement',
  isCarrierApplicationRequestSent: 'Special carrier requirement',
  isAor: 'Cancel their plan due to change of AOR',
  isInitialPayments: 'Set up initial payment',
  isAutoPay: 'Set up auto-pay',
};

const PAYMENT_ACTION_KEYS = ['isInitialPayments', 'isAutoPay'];

export const getEmployeeActions = (
  enrollmentCommunicationConditions?: Partial<CommunicationDisplayConditionsDto>,
  isOnlyPaymentActions = false
) => {
  if (!enrollmentCommunicationConditions) return [];

  const isEnrollmentConditionKey = (
    key: string
  ): key is keyof typeof enrollmentCommunicationConditions => {
    return key in enrollmentCommunicationConditions;
  };

  return Object.entries(EMPLOYEE_ACTION_LABELS)
    .filter(([actionKey]) => {
      if (isOnlyPaymentActions && !PAYMENT_ACTION_KEYS.includes(actionKey)) {
        return false;
      }

      return (
        isEnrollmentConditionKey(actionKey) &&
        enrollmentCommunicationConditions[actionKey] === true
      );
    })
    .map(([, actionLabel]) => actionLabel);
};
